module.exports = __webpack_public_path__ + "static/media/logo.ad8c02c3.png";